import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Control } from "react-hook-form";
import { Position } from "@/services/positionService";

interface CertificationsFormProps {
  control: Control<any>;
  positions?: Position[];
}

export const CertificationsForm = ({
  control,
  positions,
}: CertificationsFormProps) => {
  return (
    <>
      <CardHeader>
        <CardTitle>Certifications</CardTitle>
      </CardHeader>
      <CardContent>
        <FormField
          control={control}
          name="eligiblePositionIds"
          render={() => (
            <FormItem>
              <div className="mb-4">
                <FormLabel>Eligible Positions</FormLabel>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {positions &&
                  positions.map((position) => (
                    <FormField
                      key={position.id}
                      control={control}
                      name="eligiblePositionIds"
                      render={({ field }) => {
                        return (
                          <FormItem
                            key={position.id}
                            className="flex flex-row items-start space-x-3 space-y-0"
                          >
                            <FormControl>
                              <Checkbox
                                checked={field.value?.includes(position.id)}
                                onCheckedChange={(checked) => {
                                  return checked
                                    ? field.onChange([
                                        ...field.value,
                                        position.id,
                                      ])
                                    : field.onChange(
                                        field.value?.filter(
                                          (value) => value !== position.id,
                                        ),
                                      );
                                }}
                              />
                            </FormControl>
                            <FormLabel className="font-normal">
                              {position.tableName}
                            </FormLabel>
                          </FormItem>
                        );
                      }}
                    />
                  ))}
              </div>
            </FormItem>
          )}
        />
      </CardContent>
    </>
  );
};
